export default {
    contained: {
        boxShadow:
            '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
        backgroundColor: '#FFFFFF'
    },
    outlined: {
        borderRadius: 11,
        color: 'black'
    },
    containedPrimary: {
        boxShadow: 'none',
        backgroundColor: '#f39c12',
        color: 'white',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#fca61c',
            boxShadow: 'none',
        },
    },
    containedSecondary: {
        boxShadow: 'none',
        backgroundColor: '#2c3e50',
        color: 'white',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#39526b',
            boxShadow: 'none',
        },
    },
    
};
